import { render, staticRenderFns } from "./LocalNotes.vue?vue&type=template&id=63ec648e&scoped=true&"
import script from "./LocalNotes.vue?vue&type=script&lang=js&"
export * from "./LocalNotes.vue?vue&type=script&lang=js&"
import style0 from "./LocalNotes.vue?vue&type=style&index=0&id=63ec648e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ec648e",
  null
  
)

export default component.exports